/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CarveOutAttemptChannel = {
    PortalRpa: 'portal_rpa',
    Efax: 'efax',
    ManualDownload: 'manual_download',
} as const;
export type CarveOutAttemptChannel = typeof CarveOutAttemptChannel[keyof typeof CarveOutAttemptChannel];


export function instanceOfCarveOutAttemptChannel(value: any): boolean {
    for (const key in CarveOutAttemptChannel) {
        if (Object.prototype.hasOwnProperty.call(CarveOutAttemptChannel, key)) {
            if (CarveOutAttemptChannel[key as keyof typeof CarveOutAttemptChannel] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CarveOutAttemptChannelFromJSON(json: any): CarveOutAttemptChannel {
    return CarveOutAttemptChannelFromJSONTyped(json, false);
}

export function CarveOutAttemptChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutAttemptChannel {
    return json as CarveOutAttemptChannel;
}

export function CarveOutAttemptChannelToJSON(value?: CarveOutAttemptChannel | null): any {
    return value as any;
}

export function CarveOutAttemptChannelToJSONTyped(value: any, ignoreDiscriminator: boolean): CarveOutAttemptChannel {
    return value as CarveOutAttemptChannel;
}

